(() => {
  const canonicalProducts = new Map([
    ['kevaero-origin-oversized-tee', 'https://kevaero.de/products/kevaero-origin-oversized-tee'],
    ['kevaero-compression-shirt-herren', 'https://kevaero.de/products/kevaero-compression-shirt-herren'],
    ['kevaero-sculpt-scrunch-leggings', 'https://kevaero.de/products/kevaero-sculpt-scrunch-leggings'],
    ['kevaero-sculpt-sports-bra', 'https://kevaero.de/products/kevaero-sculpt-sports-bra'],
    ['kevaero-sculpt-set-leggings-sports-bra', 'https://kevaero.de/products/kevaero-sculpt-set-leggings-sports-bra'],
  ]);

  const normalizeProductLinks = (root = document) => {
    root.querySelectorAll?.('a[href*="/products/"]').forEach((link) => {
      const match = link.getAttribute('href')?.match(/\/products\/([^/?#]+)/);
      const canonicalUrl = match && canonicalProducts.get(match[1]);
      if (canonicalUrl) link.href = canonicalUrl;
    });
  };

  normalizeProductLinks();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) normalizeProductLinks(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
